import { useQuery } from '@tanstack/react-query';
import { shouldUseReferralProgramV2 } from '~/growthbook';
import { referralService } from '../referralService';
import { IGetReferrerResponse } from '../referralTypes';

export const useGetReferrer = () => {
  const { data, isLoading, error } = useQuery<IGetReferrerResponse, Error>({
    queryKey: ['referrer'],
    queryFn: () => referralService.getReferrer(),
    enabled: shouldUseReferralProgramV2(),
  });

  return { data: data?.referrer || null, isLoading, error };
};
